module.exports = ".avatar-center {\r\n  margin-bottom: 10px;\r\n  margin-top: 10px;\r\n  height: 130px;\r\n  width: 130px;\r\n  border: lightgray 5px solid;\r\n}\r\n\r\n.line-breaker {\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.push-0 {\r\n  margin-bottom: 0px !important;\r\n}\r\n\r\np {\r\n  text-align: justify;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/agreement-modal/agreement-modal.component.css
// module id = ./src/app/shared/components/agreement-modal/agreement-modal.component.css
// module chunks = main